/*
* 车辆里程管理组件
* zxw
* 创建时间：
* 修改时间：2026-07-08
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    message,
    Table,
    Select,
    Statistic,
    Tag,
    theme,
    Space,
} from 'antd';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    GetButtonActionName,
} from '../../incs/FunHelper.js';

const MODULENAME = CNF.navItems[1].submenu[3].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[3].ptn;
const MODULENAME_URL = CNF.navItems[1].submenu[3].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, refresh } = props;

    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorError,
            colorErrorBg,
            pageSize,
        },
    } = theme.useToken();

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh]);

    const hasOpPerm = (
        btnLists.includes(MODULENAME_PTN + '_delete')
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '车牌号码', dataIndex: 'license_number', key: 'license_number', },
        { title: '购买时间', dataIndex: 'purchase_time', key: 'purchase_time', },
        {
            title: '当前里程(km)', key: 'current_mileage',
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '30%' }}><Statistic styles={{ content: { fontSize: CNF.fontSize - 2, color: colorPrimary } }} value={record.current_mileage} /></Tag>
        },
        {
            title: '新增里程(km)', key: 'add_mileage',
            render: (record) => <Tag color={colorErrorBg} style={{ width: '30%' }}><Statistic styles={{ content: { fontSize: CNF.fontSize - 2, color: colorError } }} value={record.add_mileage} /></Tag>
        },
        { title: '所属月份', dataIndex: 'month', key: 'month', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetButtonActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, colorPrimary, colorPrimaryBg, colorError, colorErrorBg, hasOpPerm, operation]);
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
        </>
    );
}

const CarMileage = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);

    const [carLists, setCarLists] = useState([]);
    const [carUlid, setCarUlid] = useState('');

    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    useEffect(() => {
        // 获取车辆下拉列表
        const params = {
            rss: 'list',
            page_size: CNF.maxPageSize,
            current_index: 1
        };
        $.ajax({
            url: `${CNF.api}cars${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setCarLists(data.dat || []);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }, [messageApi]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            car_ulid: carUlid,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        })
            .done((data) => {
                if (data.res === 0) {
                    setDataLists(data.dat || []);
                    setPageCount(data.cnt || 0);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            })
            .fail((err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            })
            .always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, carUlid]);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleCarUlidChange = useCallback((value) => {
        setCarUlid(value);
        setCurrentIndex(1);
    }, []);

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Select
                    showSearch
                    allowClear
                    placeholder='请选择车辆'
                    style={{ width: '100%' }}
                    onChange={handleCarUlidChange}
                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                    options={carLists && carLists.map((item, index) => ({
                        key: index,
                        value: item.key,
                        label: item.license_number,
                    }))}
                />
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                refresh={refresh}
                loading={loading}
            />
        </>
    );
}

export default CarMileage